import React from 'react';
import { _storageTimeoutExpired } from '../../utils/helpers';
import ModalContainer from '../Common/Modal/ModalContainer';
import { TimerCountdown } from './TimerCountdown';

const MODAL_TIMER_DURATION = 3 * 60;

export const SessionTimeoutModal = (props) => {
  const { showModal, handleClose, handleLogout, } = props;
  const getModalText = () => {
    return <div role={'alert'}>
      Your session is about to time out due to
      <br />
      inactivity. All unsaved work will be lost.
    </div>
  };
  const getTitle = () => {
    return (
      <React.Fragment>
        <i className="far lsn-red fa-exclamation-triangle"></i>
        <span className={'text-label'}>Your Session will time out in</span>
        <TimerCountdown
          className={'session-timer'}
          seconds={MODAL_TIMER_DURATION}
          timeOut={() => {
            if (_storageTimeoutExpired()) {
              handleLogout();
            } else {
              handleClose();
            }
          }}
        />
      </React.Fragment>
    );
  };
  return (
    <ModalContainer
      aria-label='Your Session will time out in 3:00'
      size='small'
      isOpen={showModal}
      toggle={handleClose}
      buttons={[
        { onClick: handleClose, label: 'Continue working' }
      ]}
      title={getTitle()}
      text={getModalText()}
    />
  );
};

export default SessionTimeoutModal;
